export const SHOW_BANNER = 'SHOW_BANNER';
export const HIDE_BANNER = 'HIDE_BANNER';
export const REGISTER_BANNER = 'REGISTER_BANNER';
export const DEREGISTER_BANNER = 'DEREGISTER_BANNER';

export const showBanner = payload => ({
  type: SHOW_BANNER,
  payload,
});
export const hideBanner = () => ({ type: HIDE_BANNER });

export const registerBanner = payload => ({
  type: REGISTER_BANNER,
  payload,
});

export const deregisterBanner = payload => ({
  type: DEREGISTER_BANNER,
  payload,
});

const initialBannersState = {
  message: null,
  type: null,
  registeredBanners: [],
};

export default (state = initialBannersState, action) => {
  switch (action.type) {
    case SHOW_BANNER: {
      const { message, values, type } = action.payload;
      return { ...state, message, values, type };
    }
    case HIDE_BANNER: {
      const { registeredBanners } = state;
      return { ...initialBannersState, registeredBanners };
    }
    case REGISTER_BANNER: {
      const { id } = action.payload;
      const { registeredBanners } = state;
      return { ...state, ...initialBannersState, registeredBanners: [id].concat(registeredBanners) };
    }
    case DEREGISTER_BANNER: {
      const { id } = action.payload;
      const { registeredBanners } = state;
      return {
        ...state,
        ...(id === registeredBanners[0] ? initialBannersState : {}),
        registeredBanners: registeredBanners.filter(bannerId => bannerId !== id),
      };
    }
    default:
      return state;
  }
};
